import { Component } from '@angular/core';
import packageJson from '../../../../package.json';

@Component({
    selector: 'szz-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
    currentYear: number = new Date().getFullYear();
    readonly appVersion: string = this.toDisplayVersion(packageJson.version);

    private toDisplayVersion(version: string): string {
        const [major, minor] = version.split('.');
        if (major && minor) {
            return `${major}.${minor}`;
        }

        return version;
    }
}
